import styled from "styled-components";

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  width: 100%;
  z-index: 3;
  background-color: white;
  position: fixed;
  top: 0;
  left: 0;
`;

const Logo = styled.img`
  width: 35px;
  height: 35px;
  border-radius: 25px;
  background-color: white;
  padding: 0px;
  border: 1px solid #e6e6e6;
`;

const LogoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
`;

const RootContainer = styled.div``;

const ProductsContainer = styled.div`
  padding: 0px;
  margin: 0px;
  height: auto;
`;

const OrderButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const modules = {
  HeaderContainer,
  Logo,
  LogoContainer,
  RootContainer,
  OrderButtonContainer,
  ProductsContainer,
};

export default modules;
